import axios from "services/auth/jwt/config";

const reportCardObjectionService = {
  getAll: (reportCard, page, status, searchString = "") => axios.get("/reportcardobjection/getall", {
    params: { reportCard, page, limit: 10, ...(status ? { status } : {}), ...(searchString ? { searchString } : {}) }
  }),
  getById: id => axios.get(`/reportcardobjection/getbyid/${id}`),
  update: (id, data) => axios.patch(`/reportcardobjection/update/${id}`, data),
  remove: id => axios.delete(`/reportcardobjection/delete/${id}`)
};

export default reportCardObjectionService;
